import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mode", "auction"]

  connect() {
    this.refresh()
  }

  refresh() {
    const auction = this.modeTarget.value === "cumulative_auction"
    this.auctionTarget.classList.toggle("hidden", !auction)
    this.auctionTarget.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !auction
    })
  }
}
